(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flash-sale-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flash-sale-scroll')) {
    customElements.define('flash-sale-scroll', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.motion !== 'true') return;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.schedule = () => {
          if (this.motionPreference.matches) {
            this.style.removeProperty('--sale-pin-offset');
            this.style.removeProperty('--sale-wave-x');
            this.style.removeProperty('--sale-wave-scale');
            if (this.frame) cancelAnimationFrame(this.frame);
            this.frame = null;
            return;
          }
          if (this.frame || !this.visible) return;
          this.frame = requestAnimationFrame(() => {
            const bounds = this.getBoundingClientRect();
            const offset = Math.min(bounds.height, Math.max(0, -bounds.top));
            this.style.setProperty('--sale-pin-offset', `${offset}px`);
            const progress = offset / Math.max(1, bounds.height);
            this.style.setProperty('--sale-wave-x', `${progress * -22}%`);
            this.style.setProperty('--sale-wave-scale', String(1 + progress * .6));
            this.frame = null;
          });
        };
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.schedule();
        });
        this.observer.observe(this);
        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', this.schedule, { passive: true });
        this.motionPreference.addEventListener('change', this.schedule);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        if (!this.schedule) return;
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        this.motionPreference.removeEventListener('change', this.schedule);
      }
    });
  }

  if (!customElements.get('flash-sale-countdown')) {
    customElements.define('flash-sale-countdown', class extends HTMLElement {
      connectedCallback() {
        const value = this.dataset.endsAt.trim();
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value)) return;
        this.deadline = Date.parse(value);
        if (!Number.isFinite(this.deadline)) return;
        this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-unit="${unit}"]`));
        this.hidden = false;
        this.update();
        if (this.deadline > Date.now()) this.interval = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      update() {
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        this.units.forEach((element, index) => { element.textContent = String(values[index]).padStart(2, '0'); });
        const ended = remaining === 0;
        this.querySelector('.flash-sale__timer').hidden = ended;
        this.querySelector('.flash-sale__timer-label').hidden = ended;
        this.querySelector('.flash-sale__ended').hidden = !ended;
        if (ended) window.clearInterval(this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
